import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { Checkbox, CheckPicker as RSCheckPicker } from "rsuite";
import { isPropDefined } from "../general/utils";
import { RSForm } from "../index";
function MultipleSelect(props) {
    const { sticky, data, value, setValue, placeholder, disabled, loading, open, onOpen, onEntering, onClose, onClean, onClick, renderMenuItem, renderValue, noSearch, noSelectAll, label, disabledItemValues, searchBy, caretAs, renderExtraFooter, className, } = props;
    const block = isPropDefined(props.block);
    const formattedData = data.length > 0 && typeof data[0] === "string"
        ? data.map((i) => ({ label: i, value: i }))
        : data;
    const allValues = formattedData.map((item) => item.value);
    const handleCheckAll = () => {
        setValue(value.length === allValues.length ? [] : allValues);
    };
    const selectAll = () => {
        if (data.length === 0)
            return undefined;
        return (_jsxs(_Fragment, { children: [!noSelectAll && (_jsx("div", { children: _jsx(Checkbox, { indeterminate: value.length > 0 && value.length < allValues.length, checked: value.length === allValues.length, onChange: handleCheckAll, children: "Select all" }) })), renderExtraFooter && _jsx("div", { children: renderExtraFooter }), noSelectAll && !renderExtraFooter && undefined] }));
    };
    return (_jsxs(_Fragment, { children: [label && _jsx(RSForm.ControlLabel, { children: label }), _jsx("span", { onClick: onClick, children: _jsx(RSCheckPicker, { sticky: sticky, searchable: !noSearch, countable: true, block: block, value: value, data: formattedData, placeholder: placeholder, disabled: disabled, onChange: setValue, loading: loading, open: open, onOpen: onOpen, onEntering: onEntering, onClose: onClose, onClean: onClean, renderExtraFooter: selectAll, renderMenuItem: renderMenuItem, renderValue: renderValue, disabledItemValues: disabledItemValues, searchBy: searchBy, caretAs: caretAs, className: className }) })] }));
}
export default MultipleSelect;
